import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import AccountNotActivated from './views/AccountNotActivated.vue';
import ActivationLinkError from './views/ActivationLinkError.vue';
import ActivationMailSent from './views/ActivationMailSent.vue';
import ForgotEmail from './views/ForgotEmail.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import ResetPassword from './views/ResetPassword.vue';
import ForgotPasswordSent from './views/ForgotPasswordSent.vue';
import CreateAccount from './views/CreateAccount.vue';
import CreatedAccount from './views/CreatedAccount.vue';

import NotAllowed from './views/NotAllowed.vue';
import ChangePassword from './views/ChangePassword.vue';
import ChangePasswordSuccess from './views/ChangePasswordSuccess.vue';
import Error from './views/Error.vue';
import Leads from './views/Leads.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/account-not-activated',
      name: 'account-not-activated',
      component: AccountNotActivated,
    },
    {
      path: '/activation-link-error',
      name: 'activation-link-error',
      component: ActivationLinkError,
    },
    {
      path: '/activation-mail-sent',
      name: 'activation-mail-sent',
      component: ActivationMailSent,
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword,
    },
    {
      path: '/change-password-success',
      name: 'change-password-success',
      component: ChangePasswordSuccess,
    },
    {
      path: '/create-account',
      name: 'create-account',
      component: CreateAccount,
    },
    {
      path: '/created-account',
      name: 'created-account',
      component: CreatedAccount,
    },
    {
      path: '/error',
      name: 'error',
      component: Error,
    },
    {
      path: '/forgot-email',
      name: 'forgot-email',
      component: ForgotEmail,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/forgot-password-sent',
      name: 'forgot-password-sent',
      component: ForgotPasswordSent,
    },
    {
      path: '/not-allowed',
      name: 'not-allowed',
      component: NotAllowed,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
    },
    {
      path: '/leads',
      name: 'leads',
      component: Leads,
    },
  ],
});
